import { gql } from '@apollo/client';

export const CREATE_COST_CENTER = gql`
    mutation CreateCostCenter($data: CostCenterCreationInput!) {
        createCostCenter(data: $data) {
            name
        }
    }
`;
